"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumBatch = startRumBatch;
const browser_core_1 = require("@datadog/browser-core");
const rawRumEvent_types_1 = require("../rawRumEvent.types");
function startRumBatch(configuration, lifeCycle, reportError, pageMayExitObservable, sessionExpireObservable, createEncoder) {
    const endpoints = [configuration.rumEndpointBuilder];
    if (configuration.replica) {
        endpoints.push(configuration.replica.rumEndpointBuilder);
    }
    const batch = (0, browser_core_1.createBatch)({
        encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */),
        request: (0, browser_core_1.createHttpRequest)(endpoints, configuration.batchBytesLimit, reportError),
        flushController: (0, browser_core_1.createFlushController)({
            messagesLimit: configuration.batchMessagesLimit,
            bytesLimit: configuration.batchBytesLimit,
            durationLimit: configuration.flushTimeout,
            pageMayExitObservable,
            sessionExpireObservable,
        }),
        messageBytesLimit: configuration.messageBytesLimit,
    });
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, (serverRumEvent) => {
        if (serverRumEvent.type === rawRumEvent_types_1.RumEventType.VIEW) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    return batch;
}
//# sourceMappingURL=startRumBatch.js.map